"use client";

import { BaseError } from "./ui.base-error";
interface GenericErrorProps {
  error: { digest?: string } & Error;
  reset: () => void;
}
const GenericError = (props: GenericErrorProps) => {
  const { error, reset } = props;

  return (
    <BaseError
      error={{
        title: "Something Went Wrong.",
        message: "We’re sorry, but something went wrong with your request. It could be a temporary issue, or the page might be unavailable.",
        code: error.digest || "500",
      }}
      reset={{
        label: "Try Again",
        func: reset,
      }}
    />
  );
};

export { GenericError };
